import { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './components/Layout/Header/Header';
import Footer from './components/Layout/Footer/Footer';
import FloatingContact from './components/Layout/FloatingContact/FloatingContact';
import ScrollToTop from './components/Layout/ScrollToTop';
import useAuthStore from './stores/useAuthStore';
import AppRoutes from './app/routes';

const AppContent = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <>
      <Toaster />
      <Header />
      <main className={`flex-1 ${isHome ? 'pt-0' : 'pt-[57px] lg:pt-[65px]'}`}>
        <Suspense fallback={
          <div className="min-h-screen flex items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-600"></div>
          </div>
        }>
          <AppRoutes />
        </Suspense>
      </main>
      <Footer />
      <FloatingContact />
    </>
  );
};

function App() {
  // Initialize Zustand hydration on app start
  useEffect(() => {
    useAuthStore.setState({ isHydrated: true });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen flex flex-col">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
